var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Regular",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,19.5c-4.135,0-7.5-3.365-7.5-7.5S7.865,4.5,12,4.5s7.5,3.365,7.5,7.5S16.135,19.5,12,19.5z M12,6c-3.308,0-6,2.692-6,6   s2.692,6,6,6s6-2.692,6-6S15.308,6,12,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,3c-0.414,0-0.75-0.336-0.75-0.75v-1.5C11.25,0.336,11.586,0,12,0s0.75,0.336,0.75,0.75v1.5C12.75,2.664,12.414,3,12,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.894,5.856c-0.2,0-0.389-0.078-0.53-0.22c-0.142-0.142-0.22-0.33-0.22-0.53c0-0.2,0.078-0.389,0.22-0.53l1.061-1.061   c0.142-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22c0.142,0.142,0.22,0.33,0.22,0.53c0,0.2-0.078,0.389-0.22,0.53   l-1.061,1.061C19.283,5.778,19.094,5.856,18.894,5.856z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75,12.75C21.336,12.75,21,12.414,21,12s0.336-0.75,0.75-0.75h1.5c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75   H21.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.955,20.705c-0.2,0-0.389-0.078-0.53-0.22l-1.061-1.061c-0.292-0.292-0.292-0.768,0-1.061   c0.142-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22l1.061,1.061c0.292,0.292,0.292,0.768,0,1.061   C20.344,20.627,20.155,20.705,19.955,20.705z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,24c-0.414,0-0.75-0.336-0.75-0.75v-1.5c0-0.414,0.336-0.75,0.75-0.75s0.75,0.336,0.75,0.75v1.5   C12.75,23.664,12.414,24,12,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.045,20.705c-0.2,0-0.389-0.078-0.53-0.22c-0.142-0.142-0.22-0.33-0.22-0.53s0.078-0.389,0.22-0.53l1.061-1.061   c0.141-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22c0.292,0.292,0.292,0.768,0,1.061l-1.061,1.061   C4.434,20.627,4.246,20.705,4.045,20.705z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,12.75C0.336,12.75,0,12.414,0,12s0.336-0.75,0.75-0.75h1.5C2.664,11.25,3,11.586,3,12s-0.336,0.75-0.75,0.75H0.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.106,5.856c-0.2,0-0.389-0.078-0.53-0.22L3.515,4.575c-0.142-0.141-0.22-0.33-0.22-0.53s0.078-0.389,0.22-0.53   c0.141-0.142,0.33-0.22,0.53-0.22s0.389,0.078,0.53,0.22l1.061,1.061c0.142,0.141,0.22,0.33,0.22,0.53s-0.078,0.389-0.22,0.53   C5.495,5.778,5.306,5.856,5.106,5.856z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default ForwardRef;